<template>
    <div id="InsuranceCertificateList">
        <div :class="`loader${loaderClass}`" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> Insurance Certificate List</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <router-link v-if="canAddInsCerti" class="btn btn-primary pull-right" v-bind:to="{name: 'InsuranceCertificateCreate'}" > <i class="fp-add"> </i>Add</router-link>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content insurance-certificate-list">
                        <data-table-filter-config :moduleName="'insCertiList'" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'insCertiList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                    ref="listInsuranceCertificateTable"
                                    mode="remote"
                                    title="Insurance Certificate"
                                    @on-page-change="onPageChange"
                                    @on-selected-rows-change="selectionChanged"
                                    @on-column-filter="onColumnFilter"
                                    @on-per-page-change="onPerPageChange"
                                    @on-sort-change="onSortChange"
                                    :totalRows="totalRecords"
                                    :columns="userColumns"
                                    :rows="rows"
                                    :pagination-options="{
                                        enabled: false,
                                        position: 'both',
                                        perPage: perPage,
                                        perPageDropdown:dropDownPerPage,
                                        dropdownAllowAll: false,
                                    }"
                                    :select-options="{
                                    enabled: insurance_certificate_value,
                                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                    selectionInfoClass: 'custom-class',
                                    selectionText: 'rows selected',
                                    clearSelectionText: 'clear',
                                    }"
                                    :search-options="{
                                    enabled: false,
                                    }">

                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <template v-if="canUpdateInsCerti">
                                                    <router-link title="Edit Insurance Certificate" class="fp-edit" v-bind:to="{name: 'InsuranceCertificateEdit',params:{id:props.row.id}}"></router-link>
                                                </template>
                                            </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>

                                    <div slot="selected-row-actions">
                                        <button v-if="insurance_certificate_value" id="deleteInsuranceCertificateBtn" v-on:click.prevent="InsuranceCertificateDelete" class="btn btn-danger">Delete</button>
                                    </div>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>

import Vue from "vue";
import EventBus from "././event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "InsuranceCertificateList",
        metaInfo() {
            return {title: "Insurance Certificate List | " +process.env.COPYRIGHT_NAME}
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
            firstLoad: 0,
            permissions: [],
            cantAccessPage: "",
            userColumns:[],
            columns: [
                  {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                 {
                    label: 'User Type',
                    field: 'ins_user_type',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "User Type", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Phone',
                    field: 'phone',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Phone", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Email',
                    field: 'email',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Email", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'City',
                    field: 'city',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "City", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'ins_location',
                    filterable: true,
                    fpFieldType:"option",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
            ],
            rows: [],
            totalRecords: 0,
            insurance_certificate_value: false,
            loading:false,
            canAddInsCerti:false,
            canUpdateInsCerti:false,
            pageKey:'_insurance_certificate_list_',
        }),
        watch:{

            //check permission change
            permissions: function (permissions) {

                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_insurance_certificate') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'delete_insurance_certificate') {
                            self.insurance_certificate_value = true;
                        }
                        if (permissions[i].name == 'add_insurance_certificate') {
                            self.canAddInsCerti = true;
                            self.canUpdateInsCerti = true;
                        }
                    }
                }

            }

        },
        created: function() {

        },
        mounted: function() {
            var self = this;

            //self.loadList();
            self.getPermissions();
        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.listInsuranceCertificateTable.unselectAllInternal();
            },

            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },

            loadList() {
                var self = this;
                self.loading = true;
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/insurance-certificate/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        // console.log(data);
                        if (data.status == "success") {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                            self.filteredFlag = false;
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,false,'insurance-certificate-list')
                    }
                });
            },

            InsuranceCertificateDelete() {
              var self = this;
                self.$swal({
                    title: 'Are you sure that you want to delete this Insurance Certificate?',
                    type: 'info',
                    showCancelButton: true,
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    showCloseButton: false,
                    showLoaderOnConfirm: true
                }).then((result) => {
                    if (result.value) {
                      var data = this.$refs['listInsuranceCertificateTable'].selectedRows;
                      var use = [];
                      for (var i = 0; i < data.length; i++) {
                          use.push(this.$refs['listInsuranceCertificateTable'].selectedRows[i].id)
                      }
                      console.log("list of IDS =", use);
                      self.loading = true;
                      $("#deleteInsuranceCertificateBtn").val("Deleting ...");
                      $.ajax({
                          url: process.env.ROOT_API + "/insurance-certificate/delete",
                          type: "POST",
                          data: 'id=' + use,
                          headers: this.ajxHeaders,
                          dataType: 'json',
                          success: function (data) {
                              self.loading = false;
                              setTimeout(function () {
                              $(".alert-success").removeClass("show");
                                  $(".alert-success").addClass("hide");
                              }, 10000);
                              setTimeout(function () {
                                  $("#deleteInsuranceCertificateBtn").val("Delete");
                              }, 10000);
                              self.rows = data.content.row;
                              if (data.code == '200') {
                                  self.rows = data.content.row;
                                  self.totalRecords = data.content.totalRecords;
                                  self.loadList();
                              }
                          },
                          error: function (jqXHR, exception) {
                              self.loading = false;
                              self.generateStatusCodeMessage(jqXHR,true,'insurance-certificate-delete')
                          }
                      });
                    } else {
                      console.log("no");
                    }
                });
            }
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/InsuranceCertificateList.vue